import '@/playlist/games/timeGame/styles/control-bar.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import AudioToggleButton from '@/components/audioToggle/AudioToggleButton';
import BackButton from '@/components/button/BackButton';
import LayoutHeader from '@/components/layout/LayoutHeader';

interface TimeGameHeaderProps {
	onBack: () => void;
	isAudioTooltipOpen?: boolean;
	small?: boolean;
}

const TimeGameHeader = ({
	onBack,
	isAudioTooltipOpen = false,
	small = false,
}: TimeGameHeaderProps) => {
	const { t } = useTranslation();

	return (
		<LayoutHeader>
			<BackButton onClick={onBack} small={small} />
			<AudioToggleButton
				tooltip={t('time_game.audio_toggle.tooltip')}
				isOpen={isAudioTooltipOpen}
				small={small}
			/>
		</LayoutHeader>
	);
};

export default TimeGameHeader;
